module.exports = __webpack_public_path__ + "img/que-bg.b32c6388.png";